jQuery(document).ready(function ($) {
  $("#change-avatar").click(function () {
    $(".change-avatar-modal").removeClass("d-none");
    $("body").addClass("disable-scroll");
  });
  $(document).mouseup(function (e) {
    let parent_container = $(".change-avatar-modal");
    if (parent_container.length && !parent_container.hasClass("d-none")) {
      let container = parent_container.find("form");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        parent_container.addClass("d-none");
        parent_container.find(".errors").html("");
        $("body").removeClass("disable-scroll");
      }
    }
  });
  $(".close-avatar-modal").click(function () {
    $(".change-avatar-modal").addClass("d-none");
    container.find(".errors").html("");
    $("body").removeClass("disable-scroll");
  });

  //Unfollow user popUP
  function hidePopup(event) {
    event.preventDefault();
    $(this).closest(".popup").fadeOut();
  }

  $(".open-popup").on("click", function (e) {
    e.preventDefault();
    $(this).next().fadeIn(200);
  });
  $(".popup__close").on("click", hidePopup);
  $(".no-button").on("click", hidePopup);

  // Ajax call when user is logged in and the meta value of marketing is NULL

  var data = {
    action: "get_id_off_logged_in_user",
  };

  $.get(myAjax.ajaxurl, data, function (response) {
    response = response.split(",");
    var currentURL = jQuery(location).attr("href");
    var prefixUrl = currentURL.match(/(.+)\:(.+)/);
    var getUserNicename = response[2];
    var emailVerified = response[3];
    var redirectUser =
      prefixUrl[1] +
      "://" +
      $(location).attr("hostname") +
      "/author/" +
      getUserNicename;

    if (
      response[1] === "" &&
      currentURL !== redirectUser &&
      response[0] !== "0" &&
      emailVerified == "1"
    ) {
      window.location.replace(redirectUser);
    }
  });

  jQuery(window).load(function () {
    jQuery(".fantasy-overlay").hide();

    jQuery(".fantasy-league-loader").hide();
  });

  //Modal for Join Season button
  $(".open").on("click", function () {
    $(".popup-overlay, .popup-content").addClass("active");
    $(".overlay-season").removeClass("hidden");
  });

  $(".close-message").on("click", function () {
    $(".email-verification").addClass("hidden");
});

  $(".close").on("click", function () {
    $(".popup-overlay, .popup-content").removeClass("active");
    $(".overlay-season").addClass("hidden");
  });

  $(".save-participant").on("click", function () {
    $(".popup-overlay, .popup-content").removeClass("active");
    $(".overlay-season").addClass("hidden");
    location.reload();
  });

  $(document).on("keydown", function (event) {
    if (
      event.code === "Escape" &&
      $(".popup-overlay, .popup-content").hasClass("active")
    ) {
      $(".popup-overlay, .popup-content").removeClass("active");
      $(".overlay-season").addClass("hidden");
    }
  });
});

jQuery(window).load(function () {
  var getAuthorNicename = jQuery("input[name=userID]").val();
  var currentURL = jQuery(location).attr("href");
  var prefixUrl = currentURL.match(/(.+)\:(.+)/);
  var userProfile =
    prefixUrl[1] +
    "://" +
    jQuery(location).attr("hostname") +
    "/author/" +
    getAuthorNicename;
  var selectedValue = jQuery("#marketing").find(":selected").text();

  if (currentURL == userProfile) {
    if (selectedValue === "Velg") {
      jQuery(".allow-section").append(" *");
      jQuery(".allow-section").css("color", "red");
      jQuery(".legal-age").append(" *");
      jQuery(".legal-age").css("color", "red");
      jQuery(".marketing-info").removeClass("d-none");
      jQuery(".marketing-info").css("color", "red");
      jQuery(".choose-marketing").css("width", "150px");

      jQuery("html, body").animate(
        {
          scrollTop: jQuery(".claim-marketing").offset().top - 100,
        },
        2000
      );
    } else {
      jQuery(".allow-section").css("color", "black");
      jQuery(".legal-age").css("color", "black");
      jQuery(".marketing-info").addClass("d-none");
    }
  }
});
